import {Row} from 'antd';
import classes from '../Pages.module.css';
import DataField from './DataField';
import DepartmentEdit from './DepartmentEdit';

const Department = (props) => {
    return(
        !props.editMode
        ?
        props.data.map((data, index) => {
            return(
                <div key={index}>
                <p></p>
                <Row className={props.editMode ? classes['RowDEX'] : classes['RowD']}>
                    <DataField 
                        editMode={false} 
                        lg={10} 
                        md={24} 
                        options={props.ad.EMPLOYEE_DEPT_CODE} 
                        type="Select" 
                        name="department" 
                        value={data.emp_det_code} 
                    />
                    <DataField 
                        editMode={false} 
                        lg={7} 
                        md={24} 
                        name="joining date" 
                        value={data.date_join ? data.date_join.format('DD-MM-YYYY') : null} 
                    />
                    <DataField 
                        editMode={false} 
                        lg={7} 
                        md={24} 
                        name="release date" 
                        value={data.date_release ? data.date_release.format('DD-MM-YYYY') : null} 
                    />
                </Row>  
                <p></p>
            </div>
            );
        })
           
        :
        <>
            <p></p>
            <DepartmentEdit deptOptions = {props.ad.EMPLOYEE_DEPT_CODE} data = {props.data} setData = {props.setData} />
        </>
    );
}

export default Department